import { GenericResult } from 'components';
import { useTranslation } from 'react-i18next';
import successIcon from 'assets/images/otp-verification-success-icon.svg';

export const OtpVerificationSuccessPage = () => {
  const { t } = useTranslation();

  return (
    <GenericResult
      icon={<img src={successIcon} />}
      title={t('smsOtpVerification.successTitle')}
      subTitle={t('smsOtpVerification.successSubtitle')}
      defaultTo="/login"
      defaultLabel={t('registration.loginNow')}
    />
  );
};
